import {h, Component} from 'preact';
import {connect} from 'react-redux';
import $ from "expose-loader?exposes=$,jQuery!jquery";
import 'jquery-file-download';
import designService from '../service/designService';
import designDomain from '../domain/designDomain';
import qrCodeService from '../service/qrCodeService';
import SaveModal from './SaveModal';
import MakeCopyModal from './MakeCopyModal';
import DuplicatedNameModal from './DuplicatedNameModal';
import Renderer from '../canvas/renderer';
import util, {
  usePreview,
  showPrintModal,
  toLogIn,
  getHomeLink,
  removeMenuObjectPlaceholders,
  getDesignSizeLabel,
  getDesignDimensions
} from '../util';
import constants, {MyMenusPath} from '../constants';
import reduce from '../reducers';
import * as actions from '../actions';
import store from "../store";
import {setLineHeights} from "../canvas/line-height";
import DropdownResize from "./DropdownResize";
import DownloadOptions from "./header/DownloadOptions";
import ShareOptions from "./header/ShareOptions";
import {fitToPage} from "../canvas/zoom";
import PublishChangesButton from './header/PublishChangesButton';
import PromotionalBanner from "./PromotionalBanner";
import NoticeBanner from "./NoticeBanner";
import AIPromoBanner from "./AIPromoBanner";
import Interactable from "../canvas/interactable";
import MOEditModal from "./MOEditModal";
import MenuObject from "../canvas/menu-object";
import {LoadingOutlined, SettingOutlined, ShareAltOutlined} from '@ant-design/icons';
import dashboardService from '../service/dashboardService';
import Spinner from './Spinner';
import "antd/lib/message/style/index.css";

import {message, Switch} from 'antd';
import {DataSettingsModal} from "./DataSettingsModal";

export default @connect(reduce, actions)
class AppHeader extends Component {
  constructor(props) {
    super();
    const options = [
      util.getSize('menu-letter'),
      util.getSize('digital-menu-board'),
      util.getSize('table-tent'),
      util.getSize('takeout-legal-trifold'),
      util.getSize('half-page-menu'),
      util.getSize('letter'),
      util.getSize('kids-menu-letter-landscape'),
      util.getSize('poster'),
      util.getSize('biz-card-landscape'),
      util.getSize('loyalty-card-landscape'),
      util.getSize('sticker-portrait'),
      util.getSize('insta-post'),
      util.getSize('insta-story'),
      util.getSize('fb-post'),
      util.getSize('fb-story'),
      util.getSize('table-tent-insert'),
      util.getSize('logo'),
      util.getSize('sandwich-board'),
      util.getSize('label-portrait'),
      util.getSize('gift-certificate-landscape'),
      util.getSize('comment-card-portrait'),
      util.getSize('rack-card-portrait'),

      // util.getSize('menu-mailer-tabloid-trifold'),
    ];
    // if (props.isAdmin || props.isDesigner) {
    //   options.push(util.getSize('biz-card-circular'));
    // }

    this.state = {
      isDataSettingsModal: false,
      isSaveModal: false,
      isMakeCopyModal: false,
      isShareModal: false,
      isDuplicatedNameModal: false,
      sizes: util.sizes,
      saveMode: 'design',
      shareMode: '',
      oldName: '',
      oldNameSet: false,
      isDownloadLoading: false,
      quitAfterSaving: false,
      isNewDropdownVisible: false,
      isClickedQRUpdate: false,
      isPublishing: false,
      options,
      isSavingBeforePrint: false,
      isFoldersDropdownOpen: false,
      isCreateNewFolder: false,
      folders: [],
      selectedFolder: null,
      isLoadingFolders: false,
      isNewDesignDropdownOpen: false,
      showNoticeBanner: false,
      noticeBannerContent: "",
      showAIPromoBanner: false,
    };

    this.showMakeCopyModal = () => {
      this.setState({isMakeCopyModal: true});
    };

    this.showSaveModal = () => {
      if (!this.props.isLogged) {
        toLogIn();
        return;
      }
      if (this.props.isTemplate || !util.hasDesignName(this.props.designName)) {
        this.setState({isSaveModal: true});
        this.setState({saveMode: 'design'});
        return;
      }
      this.save();
    };

    this.disableQRCode = (e) => {
      e.stopPropagation();

      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: 'This QR Code will be disabled and removed from your library.',
        acceptLabel: 'OK',
        declineLabel: 'Cancel',
        onAccept: () => {
          this.props.updateElementAttribute('isPublishing', true);

          qrCodeService.removeQRCode(window.data.design.qrCodeId).then(response => {
            this.props.updateElementAttribute('isPublishing', false);
          });

          window.data.design.qrCodeId = '';
        },
        onDecline: () => {
          window.ConfirmationModal.hide()
        }
      })
    };

    this.showUpgradeModal = () => {
      if (!this.props.hasPdfPermission) {
        window.MHM.ProModal.upgrade({memberId: window.data.member.id, onSuccess: this.props.setActiveMember});
      }
    };

    this.checkInSync = () => {
      qrCodeService.getShareLink(store.getState().designId).then((resp) => {
        if (resp.data) {
          store.dispatch(actions.setWebsiteToken(true));
          store.dispatch(actions.setShareLink(resp.data))
          store.dispatch(actions.setInSync(true));
        } else {
          designService.getDesignWebsiteToken(store.getState().designId).then((resp2) => {
            if (resp2.data) {
              qrCodeService.createOrUpdateShareLink(designId).then((response) => {
                if (response.data.id) {
                  store.dispatch(actions.setWebsiteToken(true));
                  store.dispatch(actions.setShareLink(resp.data))
                  store.dispatch(actions.setInSync(true));
                }
              });
            }
          });
        }
      });

      this.resetMenu();
    };

    this.deselectAndCheckInSync = () => {
      if (window.data.design.autoClickedPublish) {
        window.data.design.autoClickedPublish = false;
      } else {
        util.deselectMenuObject();
      }
      this.checkInSync();
    }

    this.resetMenu = () => {
      $('#copyLink').attr('data-hint', 'Copy Link');
      // $('#copyEmbed').attr('data-hint', 'Copy Embed Code');

      this.setState({isClickedLinkUpdate: false, isClickedQRUpdate: false});
    }

    this.showAuthOverlay = () => {
      this.props.showAuthOverlay();
    };

    this.goToRevisions = () => {
      this.props.goToView('revisions');
    };

    this.goToPrint = () => {
      removeMenuObjectPlaceholders();

      store.dispatch(actions.setReplaceFrameMode(false));
      store.dispatch(actions.deselect());
      this.props.markAsModified();
      this.props.setIsSaved(false);
      this.props.setIsSaving(true);
      this.setState({isSavingBeforePrint: true});

      designService.updateDesign({
        id: this.props.designId,
        templateId: this.props.parentId,
        name: this.props.designName,
        html: Renderer.getPagesContent(),
        size: this.props.designSize,
        lastSavedTag: this.props.lastSavedTag,
        hasChanges: true,
        hasVideo: this.props.hasVideo
      }).then((resp) => {
        if (resp.data.success) {
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);
          this.props.goToView('print');
        } else {
          util.showDesignInUseModal();
        }
        this.setState({isSavingBeforePrint: false});
      }).catch((err) => {
        console.log(err);
        this.setState({isSavingBeforePrint: false});
      })
    };

    this.showSaveTemplateModal = (ev) => {
      this.setState({isSaveModal: true});
      this.setState({saveMode: 'template'});
    };

    document.addEventListener("saveAndReload", async () => {
      await this.saveAnd('reload');
    });

    this.saveAndQuit = async () => {
      await this.saveAnd('quit');
    };

    this.saveAnd = async (type) => {
      if (!this.props.isLogged) {
        this.showSaveModal();
        return;
      }

      if (this.props.designName === 'Untitled Design') {
        this.setState({quitAfterSaving: true});
        this.showSaveModal();
        return;
      }

      $('.modal-back').show();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      let dto = this.getDesignDto();

      const $this = this;

      this.saveAsAction(
        dto,
        function (resp) {
          $this.props.setIsSaved(true);
          $this.props.setIsSaving(false);
          $this.props.setShowExitWarning(false);

          if (!$this.props.isLogged) {
            toLogIn();
            return;
          }

          if (type === 'reload') {
            window.location.reload();
          } else {
            window.location = getHomeLink();
          }
        },
        function (err) {
          if ($this.props.isTemplate) {
            designService.getDesignAlternativeName(this.props.designId, this.props.designName)
              .then((resp) => {
                $this.props.setDesignName(resp.data);
                $this.setState({oldNameSet: false});
              })
          }
        }
      )
    }

    this.showConfigureTemplateModal = () => {
      this.props.showConfigureTemplateModal();
    };

    this.onSaveModalClose = () => {
      this.setState({isSaveModal: false});
    };

    this.onMakeCopyModalClose = () => {
      this.setState({isMakeCopyModal: false});
    };

    this.onConfigureTemplateModalClose = () => {
      this.props.hideConfigureTemplateModal();
    };

    this.onDuplicatedModalClose = () => {
      this.setState({isDuplicatedNameModal: false});
    };

    this.getPromoTemplates = (size) => {
      this.props.setPublicPromoDesigns([], true);
      designService.getTemplatesByStatusAndSize('published', size.key).then(response => {
        const designs = response.data.map(design => new designDomain.Design(design, util.sizes));
        this.props.setPublicPromoDesigns(designs);
      }).catch(() => {
        this.props.setPublicPromoDesigns([], false);
      })
    };

    this.changeSize = () => {
      const size = this.state.sizes.filter(size => size.selected === true)[0];
      this.props.setDesignSize(size);

      Renderer.setPageSize(size);
      util.nextTick(() => {
        setLineHeights();
        fitToPage();
      });

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      designService.updateDesign({
        id: this.props.designId,
        size: size.key,
        hasVideo: this.props.hasVideo
      }).then(response => {
        this.props.setIsSaved(true);
        this.props.setIsSaving(false);
      });

      this.props.setPromoLoading(true);
      this.getPromoTemplates(size);
    };

    this.save = (callback) => {
      this.props.markAsModified();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);
      this.props.markAsModified();

      let dto = this.getDesignDto();

      dto.templateId = this.props.parentId;
      dto.name = this.props.designName;
      dto.size = this.props.designSize;
      dto.lastSavedTag = this.props.lastSavedTag;
      dto.hasChanges = true;

      const $this = this;

      this.saveAsAction(
        dto,
        function (resp) {
          if (resp.data.success) {
            if (resp.data.message === 'DUPLICATED_NAME') {
              $this.setState({isDuplicatedNameModal: true});
            }

            $this.props.setIsSaved(true);
            $this.props.setIsSaving(false);
            $this.setState({oldNameSet: false});

            if (!!callback) {
              callback();
            }
          } else {
            util.showDesignInUseModal();
          }
        },
        function (err) {
          if ($this.props.isTemplate) {
            if (err.message.includes('properties of undefined')) {
              window.InfoModal.show({title: 'Failed to save', body: 'This design name is already in use!'});
            }
            designService.getDesignAlternativeName(this.props.designId, this.props.designName).then((resp) => {
              $this.props.setDesignName(resp.data);
              $this.setState({oldNameSet: false});
              $this.props.setIsSaving(false);
            })
          }
        }
      )
    }

    this.onChangeDesignName = (ev) => {
      if (!this.state.oldNameSet) {
        this.setState({
          oldNameSet: true,
          oldName: this.props.designName
        })
      }
      const name = ev.target.value;
      this.props.setDesignName(name);

      // Reset width to default
      $(ev.target).css('width', '');

      if (util.hasDesignName(ev.target.value)) {
        this.save({toFocus: ev.target});
      }
    };

    this.onChangeDesignNameOnFileDropdown = (ev) => {
      if (!this.state.oldNameSet) {
        this.setState({
          oldNameSet: true,
          oldName: this.props.designName
        })
      }

      if (!ev.target.innerText) {
        ev.target.innerText = 'Untitled Design';
      }

      const name = ev.target.innerText;
      this.props.setDesignName(name);
      $(ev.target).blur();

      if (util.hasDesignName(ev.target.innerText)) {
        this.save({toFocus: ev.target});
      }
    };

    function setDesignNameWidth(textLength) {
      const minWidth = 150; // minimum width in pixels
      const maxWidth = 600; // maximum width in pixels
      const charWidth = 8;  // approximate width per character
      const newWidth = Math.max(minWidth, Math.min(maxWidth, (textLength * charWidth + 20)));

      $('#design-name').css('width', newWidth + 'px');
    }

    this.onTypeDesignName = (ev) => {
      this.props.setDesignName(ev.target.value);

      const $designName = $('#design-name');
      const textLength = $designName.val().length;
      setDesignNameWidth(textLength);
    };

    this.onClickDesignName = () => {
      const $designName = $('#design-name');
      $designName.select();

      const textLength = $designName.val().length;
      setDesignNameWidth(textLength);
    };

    this.auth = () => {
      toLogIn();
    };

    this.discardPreview = () => {
      Renderer.revertRevisionPreview();
      this.props.goToView('text');
      util.deselectMenuObject();
      this.props.setVersionPreview(false);
      util.nextTick(() => {
        window.location.reload()
      });
    };

    this.goToHomePage = async () => {
      if (this.props.iniFrame) return;

      $('.modal-back').show();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      if (this.props.hasChanges) {
        let dto = this.getDesignDto();
        dto.name = this.props.designname;
        dto.lastSavedTag = this.props.lastSavedTag;
        dto.hasVideo = this.props.hasVideo;

        await designService.updateDesign(dto);
      }

      this.props.setShowExitWarning(false);

      window.location = getHomeLink();
    };

    this.chatWithUs = () => {
      Intercom('showNewMessage');
    }

    this.showDataSettings = () => {
      this.setState({isDataSettingsModal: true});
    }

    this.onDataSettingsModalClose = () => {
      this.setState({isDataSettingsModal: false});
    }

    this.select = (size) => {
      Interactable.destroyAll();
      store.dispatch(actions.setIsAppLoading(true, "Preparing your new design..."));
      designService.updateDesign({
        id: this.props.designId,
        templateId: this.props.parentId,
        html: Renderer.getPagesContent(),
        name: this.props.designName,
        size: this.props.designSize,
        privacy: this.props.designPrivacy,
        hasVideo: this.props.hasVideo
      }).then(() => {
        this.props.setIsSaved(true);
        this.props.setIsSaving(false);
        this.props.setShowExitWarning(false);

        window.location.href = constants.appPrefix + '/design?size=' + size.key;
        // designService.quickCreateDesignBySize(size.key, this.props.locationId).then(resp => {
        //   const design = resp.data;
        //   store.dispatch(actions.setDesign(design));
        //   store.dispatch(actions.setIsNewDesign(true));
        //
        //   Renderer.populateDesign(design);
        //   util.nextTick(() => Renderer.addPage());
        //
        //   if (window.history) {
        //     window.history.replaceState({}, '', `${constants.appPrefix}/design?id=${design.id}`);
        //   }
        //
        //   getPromoTemplates(design.size);
        //   this.props.goToView("templates");
        //
        //   store.dispatch(actions.setIsAppLoading(false));
        // }).catch(() => {
        //   store.dispatch(actions.setIsAppLoading(false));
        // });

      }).catch(() => {
        store.dispatch(actions.setIsAppLoading(false));

        if (this.props.isTemplate) {
          designService.getDesignAlternativeName(this.props.designId, this.props.designName)
            .then((resp) => {
              this.props.setDesignName(resp.data);
              this.setState({oldNameSet: false});
            })
        }
      })
    }

    this.getWebsiteCode = (websiteToken) => {
      return '<script type="text/javascript">\n' +
        '\tvar timberUrlParam="&lite=true";\n' +
        '\tvar websiteToken="' + websiteToken + '";\n' +
        '\tvar width="100%";\n' +
        '\tvar height="100%";\n' +
        '</script>\n' +
        '<script type="text/javascript" src="https://' + window.location.hostname + '/js/weblink.js"></script>\n' +
        '<div id="webcode_iframe" style="box-shadow: 0 1px 2px rgba(0,0,0,0.1); border-radius: 8px; border: 1px solid #fff;"></div>';
    }

    this.getShareLink = (designId) => {
      return util.getShareLink(designId);
    };

    this.getQRCodeLink = (id) => {
      return getQRCodeDynamicUrl(id);
    };

    this.copyText = (text, e) => {
      let input = document.createElement('input');
      input.setAttribute('value', text);
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);

      if ($(e.target).parent().attr('id') == 'copyLink') { // || $(e.target).parent().attr('id') == 'copyEmbed') {
        $(e.target).parent().attr('data-hint', 'Copied!');
      }

      e.stopPropagation();
    };

    this.getDesignDto = () => {
      let dto = {
        id: this.props.designId,
        html: Renderer.getPagesContent(),
        hasVideo: this.props.hasVideo
      }

      if (window.data.design.addToFolderId) {
        dto.folders = window.data.design.addToFolderId;
      }

      if (window.data.member.ownerName) {
        dto.creatorName = window.data.member.ownerName;
      }

      return dto;
    }

    this.showFoldersDropdown = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      this.setState({isFoldersDropdownOpen: true});

      this.loadLocationFolders(() => {

      });
    };

    this.showNewDesignDropdown = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      this.setState({isNewDesignDropdownOpen: true});
    };

    //start a timer and if the user is not authenticated show him the reg modal
    util.initRegCheck();

    this.getFoldersMap = (folders) => {
      const folderMap = new Map();

      // First, create a map with folder objects using their 'id' as keys
      folders.forEach(folder => {
        folderMap.set(folder.id, {
          id: folder.id,
          name: folder.name,
          count: folder.count,
          parentId: folder.parentId ? parseInt(folder.parentId) : '',
          children: [],
        });
      });

      // Next, populate the 'children' arrays based on 'parentId'
      folders.forEach(folder => {
        if (folder.parentId) {
          const parentFolder = folderMap.get(parseInt(folder.parentId)); // Parse parentId to an integer
          if (parentFolder) {
            parentFolder.children.push(folderMap.get(folder.id));
          }
        }
      });

      // Filter out folders that have a parentId (nested folders)
      const topLevelFolders = Array.from(folderMap.values()).filter(folder => !folder.parentId);

      return topLevelFolders;
    }

    this.selectFolder = (folder, ev) => {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }

      this.setState({selectedFolder: folder});

      if (!folder) {
        this.removeFromFolder();
      }
    }

    this.findFolder = (folders, folderId) => {
      let found;

      folders.forEach(folder => {
        if (folder.id == folderId) {
          found = folder; // found it!
        } else if (folder.children.length > 0) {
          found = this.findFolder(folder.children, folderId) // didn't find it, but let's keep digging!
        }
      });

      return found;
    }

    this.goBackToParentFolder = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      if (this.state.selectedFolder) {
        if (this.state.selectedFolder.parentId) {
          const parentFolder = this.findFolder(this.state.folders, this.state.selectedFolder.parentId);
          this.selectFolder(parentFolder, ev);
        } else {
          this.selectFolder('', ev);
        }
      }

      this.setState({isCreateNewFolder: false});
    }

    this.goBackToFileDropdown = (ev) => {
      this.setState({isFoldersDropdownOpen: false, isCreateNewFolder: false});
      // this.selectFolder('', ev);
    }

    this.getFolderComponent = (folder) => {
      return <li className="folder" onClick={(ev) => this.selectFolder(folder, ev)}>
        <svg className="empty-folder">
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-folder-icon"}/>
        </svg>
        <div className='info'>
          <label className='name'>{folder.name}</label>
          <small className='count'>{folder.count} items</small>
        </div>
        <svg className="arrow">
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
        </svg>
      </li>
    }

    this.createNewFolder = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      this.setState({isCreateNewFolder: true});
    }

    this.cancelCreateNewFolder = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      this.setState({isCreateNewFolder: false});
    }

    this.saveCreateNewFolder = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (!this.state.newFolderName) return;

      let parentId = this.state.selectedFolder ? this.state.selectedFolder.id : '';

      this.setState({isLoadingFolders: true});

      dashboardService.createLocationFolder(this.props.locationId, this.state.newFolderName, this.props.memberId, parentId).then((resp) => {
        const newFolderId = resp.data.id;
        const newFolderName = resp.data.name;

        dashboardService.putDesignInFolder(this.props.designId, newFolderId, (this.props.designFolders ? this.props.designFolders : '')).then((resp) => {
          message.success(`Design ${this.props.designName} saved to ${newFolderName}`);
          this.props.setDesignFolders(newFolderId);
          this.resetFileDropdown();
        });
      });
    }

    this.removeFromFolder = () => {
      this.setState({isLoadingFolders: true});

      dashboardService.removeDesignFromFolder(this.props.designId).then((resp) => {
        message.success(`Design ${this.props.designName} saved to Saved Designs`);
        this.props.setDesignFolders('');
        this.resetFileDropdown();
      });
    }

    this.saveToFolder = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (!this.state.selectedFolder) return;

      this.setState({isLoadingFolders: true});

      dashboardService.putDesignInFolder(this.props.designId, this.state.selectedFolder.id, (this.props.designFolders ? this.props.designFolders : '')).then((resp) => {
        message.success(`Design ${this.props.designName} saved to ${this.state.selectedFolder.name}`);
        this.props.setDesignFolders(this.state.selectedFolder.id);
        this.resetFileDropdown();
      });
    }

    this.onChangeNewFolderName = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      const name = ev.target.value;
      this.setState({newFolderName: name});
    };

    this.loadLocationFolders = (callback) => {
      this.setState({isLoadingFolders: true});

      dashboardService.getLocationFolders(this.props.locationId).then((resp) => {
        if (resp.data) {
          const foldersMap = this.getFoldersMap(resp.data).sort((a, b) => a.name.localeCompare(b.name));

          this.setState({
            folders: foldersMap,
            isLoadingFolders: false,
          })
        }

        if (callback) callback();
      });
    }

    this.resetFileDropdown = () => {
      this.setState({
        isNewDesignDropdownOpen: false,
        isFoldersDropdownOpen: false,
        isCreateNewFolder: false,
        selectedFolder: null,
        newFolderName: ''
      });
    }
  }

  componentDidMount() {
    window.App = window.App || {};
    
    if (!util.getCookie('ai-banner-shown')) {
      this.setState({ showAIPromoBanner: true });
    }

    qrCodeService.getShareLink(store.getState().designId).then((resp) => {
      if (resp.data) {
        store.dispatch(actions.setWebsiteToken(true));
        store.dispatch(actions.setShareLink(resp.data))
        store.dispatch(actions.setInSync(true));
      } else {
        designService.getDesignWebsiteToken(store.getState().designId).then((resp2) => {
          if (resp2.data) {
            qrCodeService.createOrUpdateShareLink(store.getState().designId).then((response) => {
              if (response.data.success) {
                store.dispatch(actions.setWebsiteToken(true));
                store.dispatch(actions.setShareLink(resp.data))
                store.dispatch(actions.setInSync(true));
              }
            });
          }
        });
      }
    });

    this.setState({
      oldName: this.props.designName
    });

    this.saveAsAction = (dto, successFunction, errorFunction) => {
      console.log('saving as action');
      let waitingForSave = true;
      designService.updateDesign(dto).then((resp) => {
        waitingForSave = false;
        successFunction(resp);
      }).catch((err) => {
        waitingForSave = false;
        errorFunction(err);
      });

      setTimeout(() => {
        if (waitingForSave) {
          util.showSaveHangingModal();
        }
      }, constants.saveHangWaitTime * 1000);
    }

    this.onNameChange = (e) => {
      // Capture the new content when the input changes
      const newContent = e.target.innerText;
      setContent(newContent);
    };

    dashboardService.getTextBlockByName("Timber Notice").then((resp) => {
      if (resp && resp.data && resp.data.details && resp.data.details.trim()) {
        this.setState({showNoticeBanner: true, noticeBannerContent: resp.data.details});
      }
    });

    this.closeAIPromoBanner = () => {
      const now = new Date();
      now.setTime(now.getTime() + 365 * 24 * 60 * 60 * 1000);
      const expiration = 'expires=' + now.toUTCString();
      document.cookie = `ai-banner-shown=true;${expiration};path=/`;
      this.setState({ showAIPromoBanner: false });
    }
  }

  render(props, state) {
    const saveAsTemplate = props.isDesigner && !props.isTemplate ? <li><a onClick={this.showSaveTemplateModal}>
      <div className="svg-cont">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-template-icon"}/>
        </svg>
      </div>
      Save as Template
    </a></li> : null;

    const versionHistory = (<li><a onClick={this.goToRevisions}>
      <div className="svg-cont">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-history-icon"}/>
        </svg>
      </div>
      See Version History
    </a></li>);

    const size = util.sizes.filter(size => size.key === this.props.designSize)[0];
    const isA4 = size && size.key.indexOf('a4') > -1;

    const pageNumError = props.hasVideo && util.getNumberOfPages() > 3;

    const downloadButton = this.state.isDownloadLoading ?
      (<a className="link button large disabled download">
        <svg className="arrow-down downloading">
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-arrow-down"}/>
        </svg>
      </a>)
      : (<div className="dropdown hint--bottom" style="position: relative;" data-hint="Download">
        <div className="dropdown-toggle button large download"
             onClick={
               () => {
                 util.nextTick(() => {
                   util.hideDropdown();
                   $(".dropdown-download").removeClass("show");
                 });

                 this.save(() => {
                   $(".dropdown-download").addClass("show");
                 })
               }
             }>
          {this.props.isSaving ? <LoadingOutlined/> :
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#download-icon"}/>
            </svg>
          }
        </div>
        <div className="dropdown-menu dropdown-sticky extra-large dropdown-download" style="right: -32px;"
             data-close="no">
          {this.props.isSaving ? "" :
            <DownloadOptions {...props}
                             withPrintCta={true}
                             goToPrint={this.goToPrint.bind(this)}
                             setDownloadLoading={(isDownloadLoading) => this.setState({isDownloadLoading})}
                             pageNumError={pageNumError}
                             isMobile={false}/>
          }
        </div>
      </div>);

    const publishChangeButton = props.showPublishChanges ?
      <div className={`dropdown ${pageNumError ? 'hint--bottom-left' : 'hint--bottom'}`}
           data-hint={pageNumError ? 'Video design must be 3 pages or less to publish changes' : 'Publish Changes'}>
        <PublishChangesButton {...props} isMobile={false} pageNumError={pageNumError}/>
      </div>
      : "";

    const publishDsaChangeButton = (store.getState().isDSADesign) ?
      <div className={`dropdown hint--bottom publish-dsa-wrap`} data-hint={'Publish Changes'}>
        <PublishChangesButton {...props} isMobile={false} dsa={true}/>
      </div>
      : "";

    const shareButton = props.showPublishChanges ?
      <div className="dropdown">
        <div className="dropdown-toggle button large publish-changes-drop dropdown-sticky"
             onClick={this.deselectAndCheckInSync}>
          <ShareAltOutlined />
          {this.props.iniFrame ? 'Publish' : 'Share'}
        </div>
        <div
          className={`dropdown-menu dropdown-share initial large dropdown-sticky ${props.isDigitalMenuBoard ? 'digiboard' : ''}`}
          style="right: 0" data-close="no">
          {<ShareOptions {...props} pageNumError={pageNumError}/>}
        </div>
      </div>
      :
      <div className="dropdown" style="position: relative;">
        <div className="dropdown-toggle button large publish-first">
          <ShareAltOutlined />
          {this.props.iniFrame ? 'Publish' : 'Share'}
        </div>
        <div
          className={`dropdown-menu dropdown-share large dropdown-sticky ${props.isDigitalMenuBoard ? 'digiboard' : ''}`}
          style="right: 2px;" data-close="no">
          {<ShareOptions {...props} pageNumError={pageNumError}/>}
        </div>
      </div>;

    const addToCartButton =
      state.isSavingBeforePrint ?
        <a
          className={'link button large brand-cta add-to-cart ' + (props.isSocialDesign || props.isLogo || isA4 || props.isDigitalMenuBoard || props.isCustomSize ? 'hidden' : '')}>
          <LoadingOutlined/>
        </a>
        :
        <a
          className={'link button large brand-cta add-to-cart ' + (props.isSocialDesign || props.isLogo || isA4 || props.isDigitalMenuBoard || props.isCustomSize ? 'hidden' : '')}
          onClick={this.goToPrint}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#prints-icon"}/>
          </svg>
          Print
        </a>;

    const authButton = !this.props.isLogged ?
      <li><a className="link button" onClick={this.auth}>LOG IN</a></li> : null;

    const authButtonSignUp = !this.props.isLogged ?
      <li><a className="link button brand-cta" onClick={this.showSaveModal}>SIGN UP</a></li> : null;

    const ops = this.state.options.map(size => {
      return (
        <li>
          <a onClick={this.select.bind(this, size)}>
            <div className="svg-cont">
              <svg>
                <use
                  xlinkHref={constants.appPrefix + `/svg/icons.svg#size-${size.detailedCategory || size.category}-icon`}/>
              </svg>
            </div>
            {size.detailedLabel}
          </a>
        </li>
      )
    });

    let moEditModal = null;
    const showMOEditModal = store.getState().isMOEditModal && store.getState().$elements.length === 1 && MenuObject.isMenuObject(store.getState().$element);
    if (showMOEditModal) {
      const editMode = store.getState().MOEditMode;
      const id = store.getState().$element.attr('id') + (store.getState().moSelectedItemIdx || 0) + (store.getState().moLastSortDate || 0);
      moEditModal = <MOEditModal
        key={id}
        editType={editMode}
        uploadedIcons={props.uploadedIcons}
        setUploadedIcons={props.setUploadedIcons}/>;
    } else {
      $('.items .item.selected').removeClass('selected');
      Interactable.getIfExists(store.getState().$element)?.destroySortable();
    }

    const {width, height, unit} = getDesignDimensions(props);
    const sizeLabel = getDesignSizeLabel(props);
    let currentSizeLabel = width ? `${sizeLabel} - ${width} x ${height} ${unit}` : '';

    const mainContent =
      <div>
        <header id="app-header" className="main slide-in-top">
          {state.showNoticeBanner && <NoticeBanner content={state.noticeBannerContent}/>}
          {state.showAIPromoBanner && <AIPromoBanner
            open={state.showAIPromoBanner}
            onClose={this.closeAIPromoBanner}
          />}

          {!this.props.iniFrame &&
            <div className="back-group" onClick={this.goToHomePage}>
              <a className="logo">
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                </svg>
              </a>

              <div className="timber-icon-ct">
                <svg className="timber-icon">
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-timber-icon"}/>
                </svg>
              </div>
              <div>
                <div className="design-label">Design</div>
              </div>
            </div>
          }

          {this.props.iniFrame &&
            <svg className="mhm-logo">
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-logo"}/>
            </svg>
          }

          <nav className="file">
            <ul>
              {!window.data.member.hasViewOnlyPermission &&
                <li>
                  <div className="dropdown">
                    <a className="dropdown-toggle" onClick={this.resetFileDropdown}>File</a>
                    <div className="dropdown-menu dropdown-sticky file-dropdown" data-close="yes">
                      {state.isFoldersDropdownOpen ?
                        <div className="folders-dropdown">
                          <h3>
                            <svg onClick={(ev) => this.goBackToFileDropdown(ev)}>
                              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                            </svg>
                            Save to Folder
                          </h3>

                          {state.isLoadingFolders ? <Spinner/> :
                            <div>
                              {
                                state.selectedFolder &&
                                <div className='selected-folder'>
                                  <h4 className='folder-name'>
                                    <svg onClick={(ev) => this.goBackToParentFolder(ev)}>
                                      <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                                    </svg>
                                    {state.selectedFolder.name}
                                  </h4>
                                </div>
                              }

                              {state.isCreateNewFolder ?
                                <div className="create-new-folder">
                                  <label>Name your folder</label>
                                  <input onKeyUp={this.onChangeNewFolderName} onClick={(ev) => {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                  }} placeholder="Enter a folder name"/>
                                </div>
                                :
                                state.selectedFolder ?
                                  state.selectedFolder.children.length > 0 ?
                                    <ul>
                                      {state.selectedFolder.children.map(folder => {
                                        return this.getFolderComponent(folder)
                                      })}
                                    </ul>
                                    : <div className='move-here-message'>
                                      Move here or create a new folder.
                                    </div>
                                  :
                                  <ul>
                                    <li className="folder" onClick={(ev) => this.selectFolder('', ev)}>
                                      <svg className="empty-folder">
                                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-folder-icon"}/>
                                      </svg>
                                      <div className='info'>
                                        <label className='name'>Saved Designs</label>
                                        <small className='count'></small>
                                      </div>
                                    </li>

                                    {state.folders.map(folder => {
                                      return this.getFolderComponent(folder)
                                    })
                                    }
                                  </ul>
                              }
                            </div>
                          }

                          <div className={"footer " + (state.isCreateNewFolder ? 'create-new-folder-footer' : '')}>
                            {state.isCreateNewFolder
                              ? <div>
                                <a onClick={this.cancelCreateNewFolder} className={'btn secondary4'}>Cancel</a>
                                <a onClick={this.saveCreateNewFolder}
                                   className={'btn primary ' + (!this.state.newFolderName || this.state.isLoadingFolders ? 'disabled' : '')}>Create</a>
                              </div>
                              : <div>
                                <a onClick={this.createNewFolder}><b>+ Create new folder</b></a>
                                <a onClick={this.saveToFolder}
                                   className={'btn primary ' + (!this.state.selectedFolder || this.state.isLoadingFolders ? 'disabled' : '')}>Save</a>
                              </div>
                            }
                          </div>
                        </div>
                        :
                        state.isNewDesignDropdownOpen ?
                          <div class="new-design-dropdown">
                            <h3>
                              <svg onClick={(ev) => this.goBackToFileDropdown(ev)}>
                                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
                              </svg>
                              Create a New Design
                            </h3>
                            <ul>{ops}</ul>
                          </div>
                          :
                          <ul>
                            <li className="bottom-sep file-header">
                              <div>
                                <h3 contentEditable="true"
                                    onClick={(ev) => ev.stopPropagation()}
                                    onInput={util.debounce(this.onChangeDesignNameOnFileDropdown, 1500)}
                                    dangerouslySetInnerHTML={{__html: props.designName}}>
                                </h3>
                                <svg>
                                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-edit"}/>
                                </svg>
                              </div>
                              <span>{currentSizeLabel} &#8226; By {props.memberName}</span>
                            </li>
                            {!props.iniFrame && props.hasTemplatesPermission && <li>
                              <a onClick={this.showNewDesignDropdown}>
                                <div className='svg-cont'>
                                  <svg>
                                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-new-design-icon"}/>
                                  </svg>
                                </div>
                                New Design
                              </a>
                            </li>}
                            <li>
                              <a onClick={this.showSaveModal} style={{justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                  <div className='svg-cont'>
                                    <svg style={{height: 17}}>
                                      <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-cloud-icon"}/>
                                    </svg>
                                  </div>
                                  Save
                                </div>
                                <i
                                  className={this.props.isLogged && this.props.isSaved && !this.props.isSaving ? '' : 'hidden'}>changes
                                  saved</i>
                                <i
                                  className={this.props.isLogged && !this.props.isSaved && this.props.isSaving ? '' : 'hidden'}>saving...</i>
                              </a>
                            </li>
                            {!props.iniFrame &&
                              <li className={this.props.isLogged ? '' : 'hidden'}>
                                <a onClick={this.showFoldersDropdown}>
                                  <div className='svg-cont'>
                                    {this.props.designFolders
                                      ? <svg>
                                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-move-to-folder-icon"}/>
                                      </svg>
                                      : <svg>
                                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-folder-small-icon"}/>
                                      </svg>
                                    }
                                  </div>
                                  {this.props.designFolders ? 'Move to Folder' : 'Save to Folder'}
                                </a>
                              </li>
                            }
                            {!props.iniFrame && <li className={this.props.isLogged ? '' : 'hidden'}>
                              <a onClick={this.showMakeCopyModal}>
                                <div className='svg-cont'>
                                  <svg>
                                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy-file-icon"}/>
                                  </svg>
                                </div>
                                Make a copy
                              </a>
                            </li>}
                            {!props.iniFrame && saveAsTemplate}
                            {!props.iniFrame && versionHistory}
                            {/* {!props.iniFrame && <li><a onClick={this.saveAndQuit}>Exit</a></li>} */}
                            {/* <li>
                              <a onClick={this.showDataSettings}>
                                <SettingOutlined/>
                                Data Settings
                              </a>
                            </li> */}

                            <li className="top-sep">
                              <a href="https://intercom.help/musthavemenus-289b0117ae34/en" target="_blank">
                                <div className='svg-cont'>
                                  <svg>
                                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-help-icon"}/>
                                  </svg>
                                </div>
                                Help center
                              </a>
                            </li>
                            <li>
                              <a onClick={this.chatWithUs}>
                                <div className='svg-cont'>
                                  <svg>
                                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-chat-icon"}/>
                                  </svg>
                                </div>
                                Chat with us
                              </a>
                            </li>
                          </ul>
                      }
                    </div>

                    {/* <div id="new-design-dropdown" className="dropdown-menu medium">
                    <div className="header">
                      Start a new design
                    </div>
                    <div className="scroller">
                      <ul>{ops}</ul>
                    </div>
                  </div> */}
                  </div>
                </li>}

              {!window.data.member.hasViewOnlyPermission && !this.props.iniFrame &&
                <li>
                  <div className="dropdown" style="position: relative;">
                    <div className="tgl link button resize dropdown-toggle"><span>Resize</span></div>
                    <DropdownResize/>
                  </div>
                </li>
              }

              {!window.data.member.hasViewOnlyPermission &&
                <li className={'name ' + (this.props.isLogged ? '' : ' hidden')}>
                  <input id={'design-name'}
                         placeholder="Untitled Design"
                         value={props.designName}
                         onBlur={this.onChangeDesignName}
                         onKeyUp={this.onTypeDesignName}
                         onFocus={this.onClickDesignName}

                  />
                </li>}

              <li className={this.props.isLogged ? 'hidden' : ' '}>
                <a className="link emph" onClick={this.showSaveModal}>Save your design</a>
              </li>
              {!window.data.member.hasViewOnlyPermission &&
                <li className="saved-text">
                  <i className={this.props.isSaved && !this.props.isSaving ? '' : 'hidden'}>changes saved</i>
                  <i className={!this.props.isSaved && this.props.isSaving ? '' : 'hidden'}>saving...</i>
                </li>}

              {/* {window.localStorage.getItem("activeImport") === "y" && */}
              {/*   <li> */}
              {/*     <div className="button rev-wiz" onClick={() => { */}
              {/*       store.dispatch(actions.setIsLeftMenuVisible(false)); */}
              {/*       store.dispatch(actions.setIsMOEditModal(false)); */}
              {/*       store.dispatch(setImportWebsiteModal(true)); */}
              {/*       util.nextTick(() => { */}
              {/*         Interactable.adjustSelectionBoxes(); */}
              {/*       }); */}
              {/*     }}> */}
              {/*       Revenue Wizard */}
              {/*     </div> */}
              {/*   </li>} */}
            </ul>
          </nav>
          <nav className="action">
            {props.view !== 'print' &&
              <ul>
                {store.getState().hasDownloadsPermission &&
                  <li className={this.props.isLogged && !this.props.iniFrame ? '' : 'hidden'}>
                    {downloadButton}
                  </li>}

                {!window.data.member.hasViewOnlyPermission &&
                  <li className={this.props.isLogged ? 'share-btn ' : 'share-btn hidden'}>
                    {shareButton}
                  </li>}

                {(!window.data.member.hasViewOnlyPermission && !store.getState().isDSADesign) &&
                  <li className={this.props.isLogged && !this.props.iniFrame ? 'share-btn ' : 'share-btn hidden'}>
                    {publishChangeButton}
                  </li>}

                {(!window.data.member.hasViewOnlyPermission && !!publishDsaChangeButton) &&
                  <li className={this.props.isLogged && !this.props.iniFrame ? 'share-btn ' : 'share-btn hidden'}>
                    {publishDsaChangeButton}
                  </li>}

                {!window.data.member.hasViewOnlyPermission &&
                  <li className={this.props.isLogged && !this.props.iniFrame ? '' : 'hidden'}>
                    {addToCartButton}
                  </li>}

                {authButton}
                {authButtonSignUp}
              </ul>
            }
          </nav>
          <div>
            <DataSettingsModal
              designId={this.props.designId}
              open={state.isDataSettingsModal}
              onModalClose={this.onDataSettingsModalClose}
              dsaAutoSyncEnabled={this.props.dsaAutoSyncEnabled}
              posAutoSyncEnabled={this.props.posAutoSyncEnabled}
              linksAutoSyncEnabled={this.props.linksAutoSyncEnabled}
            />

            <SaveModal
              open={state.isSaveModal}
              saveMode={state.saveMode}
              quitAfterSaving={state.quitAfterSaving}
              onModalClose={this.onSaveModalClose}/>
            <MakeCopyModal
              open={state.isMakeCopyModal}
              onModalClose={this.onMakeCopyModalClose}/>
            <DuplicatedNameModal
              open={state.isDuplicatedNameModal}
              onModalClose={this.onDuplicatedModalClose}/>
            {moEditModal}
          </div>
        </header>
      </div>;

    const previewContent =
      <div>
        <PromotionalBanner {...props} />
        <header id="app-header" className="main slide-in-top">
          <div className="back-group" onClick={this.goToHomePage}>
            <a className="logo">
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
              </svg>
            </a>
            <div className="timber-icon-ct">
              <svg className="timber-icon">
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-timber-icon"}/>
              </svg>
            </div>
            <div>
              <div className="design-label">Design</div>
            </div>
          </div>
          <nav className="file">
            <ul>
              <li>
                <p className="logo-meta">Version Preview</p>
              </li>
            </ul>
          </nav>
          <nav className="action">
            <ul>
              <li><a className="link" onClick={this.discardPreview}>Cancel</a></li>
              <li><a className="link" onClick={usePreview}>Restore this Version</a></li>
            </ul>
          </nav>
        </header>
      </div>;

    return this.props.isVersionPreview ? previewContent : mainContent;
  }
}
